export default __webpack_public_path__ + "static/media/clock--gradient.1825f9dc.svg";